import type { IntegrationMetric } from '@/types/meet-live-ai';

export const INTEGRATION_METRICS: IntegrationMetric[] = [
  {
    value: '<15%',
    label: 'Cost vs. Full-Time Employee',
  },
  {
    value: '24/7',
    label: 'Operational Coverage',
  },
  {
    value: '18',
    label: 'Specialized AI Agents',
  },
  {
    value: '>70%',
    label: 'Reduction In Manual Effort',
  },
];
